"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Radio = void 0;
var _index = require("../../styles/index.js");
var _styledComponents = _interopRequireDefault(require("../../styled-components.js"));
var Radio = exports.Radio = _styledComponents["default"].div.withConfig({
  displayName: "Radio",
  componentId: "sc-tr5kfi-0"
})(["", ";"], (0, _index.formCheck)());